import * as React from 'react';
import * as Mui from '@mui/material';
import * as MuiIcon from '@mui/icons-material';
import AlertSnackBar from '../utility/AlertSnackBar';
import { useAppDispatch } from '../../store/configureStore';
import { markAsCompleted, storeReportInfo } from '../../store/slices/reportSlice';

export default function MarkAsCompleteModal({ completed }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const showCompletedIcon = () =>
    completed ? <MuiIcon.CheckBox /> : <MuiIcon.CheckBoxOutlineBlank />;
  const dispatch = useAppDispatch();

  const markComplete = () => {
    dispatch(markAsCompleted());
    dispatch(storeReportInfo());
  };

  const handleMarkAsComplete = () => {
    markComplete();
    handleClose();
  };

  return (
    <Mui.Box>
      <AlertSnackBar handleClose={handleClose} autoHideDuration={6000} />
      <Mui.Button
        variant="outlined"
        color="info"
        id="markAsCompleteButton"
        data-testid="markAsComplete"
        startIcon={showCompletedIcon()}
        onClick={handleOpen}
        disabled={completed}
      >
        Mark As Complete
      </Mui.Button>
      <Mui.Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Mui.Box sx={{ ...boxStyling }}>
          <Mui.Typography sx={{ ...contentStyling, ...headingStyling }} variant="h6" component="h2">
            Mark report as complete?
          </Mui.Typography>
          <Mui.Typography sx={{ ...contentStyling, ...bodyStyling }}>
            This action will change the report status from draft to complete. Completed reports are
            read only and cannot be edited. Would you like to proceed?
          </Mui.Typography>
          <Mui.Box sx={{ ...paddingStyling }}>
            <Mui.Button sx={{ ...cancelStyling }} onClick={handleClose}>
              Cancel
            </Mui.Button>
            <Mui.Button sx={{ ml: 2 }} onClick={handleMarkAsComplete} color="info" variant="text">
              Mark As Complete
            </Mui.Button>
          </Mui.Box>
        </Mui.Box>
      </Mui.Modal>
    </Mui.Box>
  );
}

const paddingStyling = {
  display: 'flex',
  justifyContent: 'flex-end',
};

const headingStyling = {
  fontWeight: 600,
};

const bodyStyling = {
  pt: 2,
};

const hoverStyling = {
  '&:hover': {
    color: 'info',
    transition: '250ms',
    cursor: 'pointer',
  },
};

const boxStyling = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.default',
  borderRadius: '4px',
  boxShadow: 24,
  p: 3,
};

const contentStyling = {
  color: (theme) => theme.palette.text.primary,
};

const cancelStyling = {
  ...paddingStyling,
  ...hoverStyling,
  color: (theme) => theme.palette.text.primary,
};
